import {
	closeAllMessageBoxesAction,
	getDefaultLanguage,
	getMLProperty,
	getMLValueGeneratorSelector,
	getMLValueSelector,
	getSelectedCultureName,
	HTTPRequest,
	MainUtils,
	MessageBox,
	Mobile,
	panelType,
	ProjectHelper,
	ServiceList
} from '@bimser/common';
import { BCMessage, BCNotification, findMessage } from '@bimser/components';
import {
	createGuid,
	IBaseAction,
	ILanguage,
	isNullOrUndefined,
	lazyRetry,
	MLHelper
} from '@bimser/core';
import { changeForMobileStateAction, closeFlexPanelByIdTransactionAction } from 'app-main/actions';
import { WebInterfaceBaseState } from 'common/base/state';
import { IRelatedPanel } from 'common/entities';
import { List } from 'immutable';
import {
	LegacyFramePanelContent,
	LegacyFramePanelContentFactoryFromJS
} from 'modules/legacyFrame/entities';
import { call, cancel, fork, put, select, take } from 'redux-saga/effects';
import { OPEN_DATA_SECURITY_TRANSACTION } from '../../../../../src/modules/dataSecurity/actions/actionTypes';
import { OPEN_LICENCE_MANAGEMENT_TRANSACTION } from '../../../../../src/modules/licenceManagement/actions/actionTypes';
import { OPEN_LOG_VIEWER_PANEL_ACTION } from '../../../../../src/modules/logviewer/actions/actionTypes';
import { OPEN_SECURITY_PANEL } from '../../../../../src/modules/security/actions/actionTypes';
import { OPEN_TASK_MANAGEMENT_TRANSACTION } from '../../../../../src/modules/taskManagement/actions/actionTypes';
import {
	panelAddNewToStoreAction,
	panelOnChangeLoadingStatusTransaction,
	setPanelContentAction
} from '../../../../common/actions';
import * as commonActionTypes from '../../../../common/actions/actionTypes';
import { AppFormPanelContentFactory } from '../../../../common/components/appForm/entities/IAppFormPanelContent';
import openPanelComponent from '../../../../common/components/panelComponent/sagas/openPanelComponent';
import { panelMenuItemSetActiveClickedAction } from '../../../../common/components/panelMenu/actions';
import {
	childrenDisplayMode,
	nodeActionType
} from '../../../../common/components/panelMenu/entities/enums';
import { IMenu } from '../../../../common/components/panelMenu/entities/IMenu';
import { PanelMenuPanelContentFactoryFromJS } from '../../../../common/components/panelMenu/entities/IPanelMenuPanelContent';
import { actionRole } from '../../../../common/entities/enums';
import { IMenuItem, MenuItem } from '../../../../common/entities/IMenuItem';
import {
	WebInterfaceAction,
	WebInterfaceActionFactoryFromJS
} from '../../../../common/entities/IWebInterfaceAction';
import { openNewPanelInsteadOfTheOtherOne } from '../../../../common/sagas/commonSagas';
import { handleGetDmParameters } from '../../../../modules/dashboard/sagas/widgets/RecentFilesManager';
import { OPEN_INDEX_REPORT_TRANSACTION } from '../../../../modules/indexReport/actions/actionTypes';
import AdminToolType from '../../../../modules/user/entities/AdminToolType';
import { DEPLOY_AGENT_READY } from '../../../../modules/workflow/actions/actionTypes';
import { IFlowViewerProps } from '../../../../modules/workflow/components/flowViewer/entities';
import { FlowDocumentType } from '../../../../modules/workflow/components/flowViewer/entities/enums';
import { IFlowStartParametersResponse } from '../../../../modules/workflow/components/flowViewer/entities/IFlowStartParametersResponse';
import { FlowViewerPanelContentFactoryFromJS } from '../../../../modules/workflow/components/flowViewer/entities/IFlowViewerPanelContent';
import { IFlowDocument } from '../../../../modules/workflow/components/flowViewer/entities/models/IFlowDocument';
import { FlowViewerParameters } from '../../../../modules/workflow/components/flowViewer/sagas/helper/openFlowViewer';
import * as appMainActionTypes from '../../../actions/actionTypes';
import { INITIALIZE_LEFT_MENU_FOR_MOBILE_TRANSACTION } from '../../../actions/actionTypes';
import { IMobileQueryString } from '../../../entities/IMobileQueryString';
import { IRedirectProcessRequestModel } from '../../../entities/IRedirectQueryString';
import { clickBreadCrumbTransaction } from '../../../sagas/clickBreadCrumbTransaction';
import {
	leftMenuSaveItems,
	leftMenuSetActiveNodeKey,
	leftMenuToggleActive,
	seteBA6Enabled
} from '../actions';
import * as leftMenuActionTypes from '../actions/actionTypes';
import { LinkOpenType } from '../entities';
import { LeftMenuState, LeftMenuStateFactoryFromJS } from '../entities/ILeftMenuState';
import { filterDesignerItems, findMenuItemWithParameter, sortItemChildren } from '../helpers';
import { openEBA6IntegrationModal } from './eBA6IntegrationModalManager';
import sendIFrameJson from './sendIFrameJson';

export default function* watchLeftMenuManagerTransaction() {
	const action: IBaseAction<WebInterfaceAction> = yield take(
		(action: IBaseAction<WebInterfaceAction>) => {
			if (
				(action.type === commonActionTypes.INITIALIZE_PANEL_MANAGER &&
					action.payload &&
					action.payload.panelType === panelType.LeftMenu) ||
				action.type === INITIALIZE_LEFT_MENU_FOR_MOBILE_TRANSACTION
			) {
				return true;
			}
		}
	);
	yield fork(leftMenuManager, action);
}

const parent: IRelatedPanel = {
	panelGuid: 'LEFTMENU',
	panelType: panelType.LeftMenu
};

export function* leftMenuManager(action: IBaseAction<WebInterfaceAction>) {
	if (action.type === INITIALIZE_LEFT_MENU_FOR_MOBILE_TRANSACTION) {
		yield call(initForMobile, action.payload.data);
	} else {
		yield call(getMenuStructure);
		yield call(checkOpenOnStartupMenuItem);
	}
	while (true) {
		const action: IBaseAction<WebInterfaceAction> = yield take(
			(action: IBaseAction<WebInterfaceAction>) => {
				if (
					[
						leftMenuActionTypes.ITEM_CLICKED,
						'ADMIN_TOOL.CLICKED_TRANSACTION',
						appMainActionTypes.REDIRECT_FOR_MOBILE,
						'ADMIN_TOOL.OPEN_MENU_DESIGNER_TRANSACTION',
						leftMenuActionTypes.CHANGE_SELECTED_PROJECT,
						leftMenuActionTypes.SAVE_ALL,
						OPEN_LOG_VIEWER_PANEL_ACTION,
						OPEN_SECURITY_PANEL,
						OPEN_TASK_MANAGEMENT_TRANSACTION,
						OPEN_DATA_SECURITY_TRANSACTION,
						OPEN_LICENCE_MANAGEMENT_TRANSACTION,
						OPEN_INDEX_REPORT_TRANSACTION
					].indexOf(action.type) > -1
				) {
					return true;
				}
				if (
					[
						'MENU_DESIGNER.OPEN_MENU_DESIGNER_PANEL',
						'MENU_DESIGNER.ONCHANGE_ITEM_DATA_TRANSACTION_ACTION'
					].indexOf(action.type) > -1 &&
					action.payload.panelType == panelType.LeftMenu
				) {
					return true;
				}
			}
		);
		switch (action.type) {
			case 'ADMIN_TOOL.CLICKED_TRANSACTION': {
				yield fork(handleAdminToolClicked, action.payload);
				break;
			}
			case OPEN_TASK_MANAGEMENT_TRANSACTION:
			case OPEN_SECURITY_PANEL:
			case OPEN_DATA_SECURITY_TRANSACTION:
			case OPEN_LOG_VIEWER_PANEL_ACTION:
			case OPEN_LICENCE_MANAGEMENT_TRANSACTION:
			case OPEN_INDEX_REPORT_TRANSACTION: {
				yield fork(handleAdminToolClicked, action.payload);
				break;
			}
			case leftMenuActionTypes.ITEM_CLICKED: {
				yield fork(handleItemClicked, action.payload);
				break;
			}
			case 'MENU_DESIGNER.OPEN_MENU_DESIGNER_PANEL': {
				yield fork(handleOpenPanelMenu, action.payload);
				break;
			}
			case appMainActionTypes.REDIRECT_FOR_MOBILE: {
				yield fork(handleRedirectForMobile, action.payload);
				break;
			}
			case 'ADMIN_TOOL.OPEN_MENU_DESIGNER_TRANSACTION': {
				const handleMenuDesignerVisiblity = yield lazyRetry(
					() => import(/* webpackChunkName: "web-left-menu" */ './designerHelper')
				).then(({ handleMenuDesignerVisiblity }) => handleMenuDesignerVisiblity);

				yield fork(handleMenuDesignerVisiblity, action.payload);
				break;
			}
			case leftMenuActionTypes.CHANGE_SELECTED_PROJECT: {
				const changeSelectedProject = yield lazyRetry(
					() => import(/* webpackChunkName: "web-left-menu" */ './designerHelper')
				).then(({ changeSelectedProject }) => changeSelectedProject);

				yield fork(changeSelectedProject, action.payload);
				break;
			}
			case leftMenuActionTypes.SAVE_ALL: {
				const saveAll = yield lazyRetry(
					() => import(/* webpackChunkName: "web-left-menu" */ './designerHelper')
				).then(({ saveAll }) => saveAll);

				yield fork(saveAll);
				break;
			}
		}
	}
}

function* checkOpenOnStartupMenuItem() {
	const menuItems = yield select((state: WebInterfaceBaseState) =>
		state.layouts.leftMenu.items.toJS()
	);
	const openOnStartupItem = findMenuItemWithParameter(menuItems, 'openOnStartup', 'true');
	if (openOnStartupItem) {
		yield call(handleItemClicked, WebInterfaceActionFactoryFromJS({ data: openOnStartupItem }));
	}
}

function* handleAdminToolClicked(payload: WebInterfaceAction) {
	let targetPanelType: panelType;
	let targetPanelTitle: string;
	let targetPanelSize: number;

	if (payload.panelType) {
		targetPanelType = payload.panelType;
	} else if (payload.data === '3') {
		targetPanelType = panelType.Security;
	}

	switch (payload.data) {
		case AdminToolType.Security:
			targetPanelTitle = findMessage.get('101210');
			targetPanelSize = 2;
			break;
		case AdminToolType.LogViewer:
			targetPanelTitle = findMessage.get('102294');
			targetPanelSize = 3;
			break;
		case AdminToolType.TaskManagement:
			targetPanelTitle = findMessage.get('102852');
			targetPanelSize = 3;
			break;
		case AdminToolType.DataSecurity:
			targetPanelTitle = findMessage.get('102894');
			targetPanelSize = 1;
			break;
		case AdminToolType.LicenceManagement:
			targetPanelTitle = findMessage.get('103315');
			targetPanelSize = 3;
			break;
		case AdminToolType.IndexReport:
			targetPanelTitle = `${findMessage.get('100720')} - ${findMessage.get('101028')}`;
			targetPanelSize = 3;
			break;
		default:
			targetPanelTitle = findMessage.get('101059');
			targetPanelSize = 3;
			break;
	}

	try {
		const state: WebInterfaceBaseState = yield select();
		let leftMenu: LeftMenuState = state.layouts.leftMenu;

		const activePanelId: string = leftMenu.activePanelId;
		const activePanelType: panelType = leftMenu.activePanelType;
		const isLogViewer: boolean = targetPanelType === panelType.LogViewer;
		const isTaskManagement: boolean = targetPanelType === panelType.taskManagement;
		const isSecurity: boolean = targetPanelType === panelType.Security;
		const isDataSecurity: boolean = targetPanelType === panelType.dataSecurity;
		const isLicenceManagement: boolean = targetPanelType === panelType.licenceManagement;
		const isIndexReport: boolean = targetPanelType === panelType.indexReport;

		if (activePanelId) {
			if (activePanelType === targetPanelType) {
				return;
			}
			yield call(changeLoadingStatus, true);
		}

		const childGuid: string = yield call(openNewPanelInsteadOfTheOtherOne, activePanelId, {
			title: targetPanelTitle,
			paneltype: targetPanelType,
			parent: parent,
			initialSize: targetPanelSize,
			size: targetPanelSize,
			canHandleCloseEvent: false,
			extraProps: { title: targetPanelTitle },
			headerHide: isLogViewer || isLicenceManagement,
			MaxButtonHide: isTaskManagement || isSecurity || isDataSecurity || isIndexReport
		});
		leftMenu = leftMenu
			.set('activePanelId', childGuid)
			.set('activePanelType', targetPanelType)
			.set('activeNodeKey', '');

		yield put(
			panelAddNewToStoreAction({
				panelId: childGuid,
				panelType: targetPanelType
			})
		);
		yield call(setLeftMenuPanelContent, leftMenu);
	} catch (e) {
	} finally {
		yield call(changeLoadingStatus, false);
	}
}

export function calculateMenuItems(
	items: IMenuItem[],
	parentPath: List<string>,
	selectedCulture: string,
	defaultLanguage: ILanguage
): IMenuItem[] {
	const result: IMenuItem[] = [];

	if (items.length > 0) {
		items.forEach((item, index) => {
			const newPath = parentPath.push(index.toString());
			const _text = getMLValueSelector(item.caption, selectedCulture, defaultLanguage);
			if (item.children && item.children.length > 0) {
				result.push({
					text: _text,
					children: calculateMenuItems(
						item.children,
						newPath,
						selectedCulture,
						defaultLanguage
					),
					icon: item.parameters.icon ? item.parameters.icon : '',
					isSubMenu: false, //(newPath.count() > 1),
					childrenDisplayMode:
						newPath.count() > 1
							? childrenDisplayMode.Panel
							: childrenDisplayMode.SubChild,
					id: item.nodeKey ? item.nodeKey : createGuid(),
					path: newPath.toJS(),
					isPinned: item.childrenDisplayMode == childrenDisplayMode.SubChild,
					enableActiveBorder: true,
					badge: {
						count: item.parameters.badge
					}
				});
			} else {
				result.push({
					text: _text,
					children: [],
					icon: item.parameters.icon ? item.parameters.icon : '',
					id: item.nodeKey ? item.nodeKey : createGuid(),
					path: newPath.toJS(),
					isSubItem: newPath.count() > 1,
					enableActiveBorder: true,
					badge: {
						count: item.parameters.badge
					}
				});
			}
		});
	}
	return result;
}

function* handleOpenPanelMenu(payload: WebInterfaceAction) {
	const parentItem: IMenuItem = payload.data;
	const parent: IRelatedPanel = {
		panelGuid: 'LEFTMENU',
		panelType: panelType.LeftMenu
	};
	const state: WebInterfaceBaseState = yield select();
	const leftMenuState: LeftMenuState = state.layouts.leftMenu;
	const activePanelId: string = leftMenuState.activePanelId;
	const activeNodeKey: string = leftMenuState.activeNodeKey;
	if (!parentItem || activeNodeKey == parentItem.id) {
		return;
	}
	const targetPanelType: panelType = state.layouts.leftMenu.menuDesigner.active
		? panelType.menuDesignerPanel
		: panelType.panelMenu;
	const selectedCulture = yield select(getSelectedCultureName);
	const defaultLanguage = yield select(getDefaultLanguage);
	const _menuItems: IMenuItem[] = calculateMenuItems(
		parentItem.children,
		List(),
		selectedCulture,
		defaultLanguage
	);

	const childGuid: string = yield call(openNewPanelInsteadOfTheOtherOne, activePanelId, {
		title: yield call(getMLValueGeneratorSelector, parentItem.caption),
		paneltype: targetPanelType,
		parent: parent,
		initialSize: 1,
		size: 1,
		extraProps: { parentItem: parentItem },
		MaxButtonHide: true,
		addNewToStore: {
			enable: true,
			setPanelDataPanelId: true,
			panelData: PanelMenuPanelContentFactoryFromJS({
				menuItems: _menuItems
			})
		},
		guid: parentItem.id
	});
	if (!childGuid) {
		yield cancel();
	}
	const panelContent = leftMenuState
		.set('activePanelId', childGuid)
		.set('activePanelType', targetPanelType)
		.set('activeNodeKey', childGuid);
	yield call(setLeftMenuPanelContent, panelContent);
}

export function* setLegacyPanel(caption: string, guid: string, url: string) {
	const legacyPanelContent: LegacyFramePanelContent = LegacyFramePanelContentFactoryFromJS({
		caption: caption,
		panelId: guid,
		url: url,
		showLoading: true
	});
	yield put(
		panelAddNewToStoreAction({
			panelId: guid,
			panelType: panelType.legacyFrame,
			data: legacyPanelContent
		})
	);
}

export function* handleOpenChildPanelSafeControls(
	selectedItem: IMenuItem,
	activeChildPanelId: string,
	_parent: IRelatedPanel,
	forMobile = false,
	closeUnpinnedPanels = false
) {
	try {
		const state: WebInterfaceBaseState = yield select();
		if (selectedItem.nodeActionType == nodeActionType.None) {
			if (selectedItem.childrenDisplayMode == childrenDisplayMode.None) {
				return;
			} else if (selectedItem.childrenDisplayMode == childrenDisplayMode.Panel) {
				const targetPanelType: panelType = state.layouts.leftMenu.menuDesigner.active
					? panelType.menuDesignerPanel
					: panelType.panelMenu;
				const panelsize: string =
					selectedItem.parameters && selectedItem.parameters['panelsize']
						? selectedItem.parameters['panelsize']
						: '1';
				const childGuid: string = yield call(
					openNewPanelInsteadOfTheOtherOne,
					activeChildPanelId,
					{
						title: yield call(getMLValueGeneratorSelector, selectedItem.caption),
						paneltype: targetPanelType,
						parent: _parent,
						initialSize: parseInt(panelsize),
						size: parseInt(panelsize),
						extraProps: { parentItem: selectedItem },
						MaxButtonHide: true,
						addNewToStore: {
							enable: true,
							setPanelDataPanelId: true,
							panelData: PanelMenuPanelContentFactoryFromJS({
								menuItems: selectedItem.children
							})
						},
						guid: selectedItem.id
					},
					false,
					closeUnpinnedPanels
				);

				return childGuid;
			} else {
				yield put(
					panelMenuItemSetActiveClickedAction({
						panelId: _parent.panelGuid,
						data: selectedItem,
						panelType: panelType.panelMenu
					})
				);
			}
		} else {
			if (activeChildPanelId) {
				if (activeChildPanelId === selectedItem.id) {
					yield fork(clickBreadCrumbTransaction, { payload: { id: activeChildPanelId } });
					return null;
				}
			}
			if (selectedItem.nodeActionType == nodeActionType.Startup) {
				if (activeChildPanelId) {
					yield put(closeFlexPanelByIdTransactionAction(activeChildPanelId));
					return selectedItem.id;
				}
			} else {
				const childGuid = yield call(
					handleOpenPanel,
					selectedItem,
					_parent,
					forMobile,
					activeChildPanelId,
					closeUnpinnedPanels
				);
				return childGuid;
			}
		}
	} catch (error) {
		if (error.status === 401) BCNotification.error({ message: findMessage.get('102860') });
		console.log('handleOpenChildPanelSafeControls error = ', error);
		throw error;
	} finally {
		yield call(changeLoadingStatus, false);
	}
}

export function* handleItemClicked(payload: WebInterfaceAction, forMobile = false): any {
	try {
		const state: WebInterfaceBaseState = yield select();
		const leftMenuItems: List<MenuItem> = state.layouts.leftMenu.items;
		const responseItem: IMenuItem = payload.data;
		if (responseItem.children.length > 0) {
			yield put(leftMenuToggleActive(payload.toJS()));
		} else if (payload.data.nodeActionType === nodeActionType.eBA6Integration) {
			const modalId = createGuid();
			yield call(openEBA6IntegrationModal, {
				id: modalId,
				item: payload.data
			});
		} else {
			let activeNodeKey = state.layouts.leftMenu.activeNodeKey;
			if (
				payload.data.nodeActionType === nodeActionType.ExternalLink &&
				payload.data?.parameters?.externalLinkOpenType !== 'On Panel'
			) {
				activeNodeKey = undefined;
			}
			const activePanelType = state.layouts.leftMenu.activePanelType;
			const activePanelId = state.layouts.leftMenu.activePanelId;

			if (activeNodeKey === responseItem.id && activePanelType !== panelType.flowHistory) {
				yield cancel();
			}

			yield call(changeLoadingStatus, true);
			const childGuid = yield call(
				handleOpenChildPanelSafeControls,
				responseItem,
				activePanelId,
				parent,
				forMobile,
				true
			);

			if (childGuid) {
				const panelContent: LeftMenuState = LeftMenuStateFactoryFromJS({
					activePanelId: childGuid,
					activePanelType: getPanelTypeFromNodeActionType(responseItem.nodeActionType),
					items: leftMenuItems.toJS(),
					activeNodeKey: responseItem.id,
					menuDesigner: state.layouts.leftMenu.menuDesigner.toJS()
				});
				yield call(setLeftMenuPanelContent, panelContent);
			} else {
				const panelContent: LeftMenuState = LeftMenuStateFactoryFromJS({
					activePanelId: '',
					activePanelType: getPanelTypeFromNodeActionType(responseItem.nodeActionType),
					items: leftMenuItems.toJS(),
					activeNodeKey: responseItem.id,
					menuDesigner: state.layouts.leftMenu.menuDesigner.toJS()
				});
				yield call(setLeftMenuPanelContent, panelContent);
			}
		}

		if (!responseItem.children.length) {
			yield ServiceList.workflow.MenuManager.OpenMenuItem.call({
				menuItemKey: responseItem.id
			});
		}
	} catch (error) {
		yield put(leftMenuSetActiveNodeKey({ data: null }));
	} finally {
		yield call(changeLoadingStatus, false);
	}
}

function getPanelTypeFromNodeActionType(type: nodeActionType) {
	switch (type) {
		case nodeActionType.HumanResources:
			return panelType.HrMenuForm;
		case nodeActionType.WorkflowManagement:
			return panelType.wfManagement;
		case nodeActionType.Startup:
			return panelType.startupLayout;
		case nodeActionType.DMExplorer:
			return panelType.dmExplorer;
		case nodeActionType.FillAForm:
			return panelType.eBAApplicationForm;
		case nodeActionType.SupersetDashboard:
			return panelType.SupersetFrame;
		default:
			return panelType.panelMenu;
	}
}

function* checkUserPermissionForForm(projectId: string, formId: string) {
	try {
		const permissionKey = `app.${projectId}.form.${formId}.view`;
		const response = yield ServiceList.main.Permission.ControlUserPermissions.call(
			{
				permissions: [permissionKey]
			},
			undefined,
			undefined,
			true
		);
		if (response) {
			return response[permissionKey];
		}
		return false;
	} catch (error) {
		console.log('🚀 -> function*checkUserPermissionForForm -> error', error);
		return false;
	}
}

function* handleOpenPanel(
	responseItem: IMenuItem,
	_parent: IRelatedPanel,
	forMobile = false,
	activePanelId = '',
	closeUnpinnedPanels = false
) {
	switch (responseItem.nodeActionType) {
		case nodeActionType.HumanResources: {
			return yield call(
				openNewPanelInsteadOfTheOtherOne,
				activePanelId,
				{
					title: findMessage.get('101045'),
					paneltype: panelType.HrMenuForm,
					parent: _parent,
					initialSize: 1,
					size: 1,
					MaxButtonHide: true,
					canHandleCloseEvent: false,
					forMobile: forMobile,
					addNewToStore: true
				},
				false,
				closeUnpinnedPanels
			);
		}
		case nodeActionType.FillAForm: {
			try {
				BCMessage.loading({
					key: 'fillAFormLoading',
					content: findMessage.get('100127'),
					duration: 0
				});
				yield call(waitAgentReady);
				const hasPermission = yield call(
					checkUserPermissionForForm,
					responseItem.parameters.projectId,
					responseItem.parameters.formId
				);
				if (!hasPermission) {
					BCNotification.warning({
						message: findMessage.get('101013')
					});
					return null;
				}

				const clientUrl = ProjectHelper.getDeploymentUrl(
					responseItem.parameters.projectName,
					null
				);
				const response = yield HTTPRequest.post(
					clientUrl + '/project/forms/GetFormInfoByName',
					{
						projectName: responseItem.parameters.projectName,
						formName: responseItem.parameters.formName,
						parameters: { menuParameters: { ...responseItem.parameters } }
					}
				);

				responseItem.parameters['clientUrl'] = clientUrl;
				const panelsize: string =
					responseItem.parameters && responseItem.parameters['panelsize']
						? responseItem.parameters['panelsize']
						: '2';
				const maxButtonVisible: string =
					responseItem.parameters && responseItem.parameters['maximizable']
						? responseItem.parameters['maximizable']
						: 'true';
				if (
					isNullOrUndefined(responseItem.parameters.openOnType) ||
					responseItem.parameters.openOnType == 'panel'
				) {
					return yield call(
						openNewPanelInsteadOfTheOtherOne,
						activePanelId,
						{
							title: null, // Bu değer form.caption.text propertysi ile yüklenecektir.
							paneltype: panelType.eBAApplicationForm,
							parent: _parent,
							initialSize: parseInt(panelsize),
							size: parseInt(panelsize),
							extraProps: {
								...responseItem.parameters,
								mobileFormView: responseItem.mobileFormView,
								parameterSecretKey: response.data.secretKey,
								packageVersion: response.data.packageVersion
							},
							canHandleCloseEvent: true,
							forMobile: forMobile,
							addNewToStore: true,
							MaxButtonHide: !(maxButtonVisible == 'true')
						},
						false,
						closeUnpinnedPanels
					);
				} else {
					if (activePanelId) {
						yield put(closeFlexPanelByIdTransactionAction(activePanelId));
					}
					const guid = createGuid();
					yield call(openPanelComponent, {
						id: guid,
						title: '',
						panelType: panelType.eBAApplicationForm,
						parentPanel: _parent,
						type: responseItem.parameters.openOnType as any,
						props: responseItem.parameters,
						closePanelId: activePanelId,
						width: MainUtils.panelSizeToWidth(+panelsize),
						addNewToStore: {
							enable: true,
							panelData: AppFormPanelContentFactory({
								openedOn: responseItem.parameters.openOnType as any
							}),
							setPanelDataPanelId: true
						},
						maskClosable: false
					});
					return guid;
				}
			} catch (error) {
				BCNotification.error({ message: findMessage.get('103709') });
				throw error;
			} finally {
				BCMessage.destroy('fillAFormLoading');
			}
		}
		case nodeActionType.WorkflowManagement: {
			return yield call(
				openNewPanelInsteadOfTheOtherOne,
				activePanelId,
				{
					title: findMessage.get('101046'),
					paneltype: panelType.wfManagement,
					parent: _parent,
					initialSize: 1,
					size: 1,
					MaxButtonHide: true,
					canHandleCloseEvent: false,
					extraProps: { mobileFormView: responseItem.mobileFormView },
					forMobile: forMobile,
					addNewToStore: true
				},
				false,
				closeUnpinnedPanels
			);
		}
		case nodeActionType.DMExplorer: {
			return yield call(
				openNewPanelInsteadOfTheOtherOne,
				activePanelId,
				{
					title: findMessage.get('100720'),
					paneltype: panelType.dmDashboard,
					parent: _parent,
					initialSize: 3,
					size: 3,
					MaxButtonHide: true,
					canHandleCloseEvent: false,
					forMobile: forMobile,
					disableResize: true,
					transparentBackground: true,
					headerHide: true
				},
				false,
				closeUnpinnedPanels
			);
		}
		case nodeActionType.StartAProcess: {
			try {
				BCMessage.loading({
					key: 'startAProcessLoading',
					content: findMessage.get('100127'),
					duration: 0
				});
				yield call(waitAgentReady);
				return yield call(
					triggerStartAProcess,
					responseItem.parameters,
					activePanelId,
					forMobile,
					undefined,
					responseItem.mobileFormView,
					true
				);
			} catch (error) {
				Mobile.MobileView.mobileServiceResponse(false, 'StartParameters', error);
				BCNotification.error({ message: findMessage.get('100704') });
				throw error;
			} finally {
				BCMessage.destroy('startAProcessLoading');
			}
		}
		case nodeActionType.AllApps: {
			return yield call(
				openNewPanelInsteadOfTheOtherOne,
				activePanelId,
				{
					title: findMessage.get('101880'),
					paneltype: panelType.AllApps,
					parent: _parent,
					initialSize: 3,
					size: 3,
					MaxButtonHide: true,
					canHandleCloseEvent: false,
					forMobile: forMobile,
					disableResize: true,
					HeaderActionsHide: true
				},
				false,
				closeUnpinnedPanels
			);
		}
		case nodeActionType.ExternalLink: {
			if (responseItem.parameters?.['externalLink']) {
				let url = responseItem.parameters['externalLink'];

				// Replace variables in the URL.
				try {
					if (typeof url === 'string' && /%[^%]+%/.test(url)) {
						BCMessage.loading({
							key: 'externalLinkLoading',
							content: findMessage.get('100127'),
							duration: 0
						});

						const result = yield ServiceList.Studio.DataSource.Query.GetVariables.call(
							null,
							false,
							{ cache: true },
							true
						);

						result.forEach(item => {
							url = url.replace(
								new RegExp(item.name, 'g'),
								isNullOrUndefined(item.value) ? '' : item.value
							);
						});
					}
				} catch (err) {
					console.error(`An error occurred while replacing variables in the URL: ${err}`);
				} finally {
					BCMessage.destroy('externalLinkLoading');
				}

				// If the external link is set to open in a new panel, open it in a new panel.
				if (responseItem.parameters['externalLinkOpenType'] === 'On Panel') {
					const panelSize = parseInt(responseItem.parameters['panelsize'] || '1');

					return yield call(
						openNewPanelInsteadOfTheOtherOne,
						activePanelId,
						{
							title: yield call(getMLValueGeneratorSelector, responseItem.caption),
							paneltype: panelType.WorkflowFrame,
							parent: _parent,
							initialSize: panelSize,
							size: panelSize,
							canHandleCloseEvent: false,
							forMobile: forMobile,
							extraProps: { url }
						},
						false,
						closeUnpinnedPanels
					);
				}

				// If the external link is set to open in a new tab, open it in a new tab.
				window.open(url, '_blank').focus();
				break;
			}
		}
		case nodeActionType.SupersetDashboard: {
			if (responseItem.parameters?.['supersetId']) {
				const panelSize = parseInt(responseItem.parameters['panelsize'] || '1');

				return yield call(
					openNewPanelInsteadOfTheOtherOne,
					activePanelId,
					{
						title: yield call(getMLValueGeneratorSelector, responseItem.caption),
						paneltype: panelType.SupersetFrame,
						parent: _parent,
						initialSize: panelSize,
						size: panelSize,
						canHandleCloseEvent: false,
						forMobile: forMobile,
						extraProps: {
							supersetId: responseItem.parameters['supersetId']
						}
					},
					false,
					closeUnpinnedPanels
				);
			}
		}
	}
}

function* triggerStartAProcess(
	parameters: any,
	activePanelId: string,
	forMobile: boolean,
	handleCloseEvent = true,
	mobileFormView = 3,
	closeUnpinnedPanels = false
) {
	parameters['clientUrl'] = ProjectHelper.getDeploymentUrl(parameters.projectName, null);
	let request: any = {
		processId: isNullOrUndefined(parameters?.processId) ? 0 : parameters.processId,
		documentParameters: {
			menuParameters: { ...parameters }
		}
	};
	if (request.processId > 0) {
		request.requestId = parameters.requestId || parameters.processRequestId;
	} else {
		delete parameters.projectVersion;
	}

	if (forMobile) {
		request = {
			processId: parameters.processId || 0,
			requestId: parameters.requestId || 0,
			documentParameters: {
				menuParameters: { ...parameters }
			}
		};
		if (request.processId > 0) {
			request.requestId = parameters.requestId;
		}
		if (parameters.scopeId) {
			request.draftScopeId = parameters.scopeId;
		}
	}
	let response = null;
	try {
		response = yield call(ProjectHelper.RunGeneratorFlowService, {
			projectName: parameters.projectName,
			projectVersion: parameters.projectVersion,
			flowName: parameters.flowName,
			serviceName: 'StartParameters',
			requestParameters: request,
			serviceMethod: 'post'
		});
		if (!response) {
			return;
		}
	} catch (error) {
		MessageBox.error({ error: error.exception.data });
		throw error;
	}

	const responseData: IFlowStartParametersResponse = response.data;
	Mobile.MobileView.mobileServiceResponse(true, 'StartParameters', response);
	yield call(getMLProperty, parameters?.flowCaption);
	let defDocumentName = null;
	const menuPanelSize = parameters.panelsize;
	let documentPanelSize = null;
	if (responseData?.documents?.length) {
		defDocumentName = getFlowDocumentNameFromDocument(responseData.documents[0]);
		documentPanelSize = responseData.documents[0].viewOptions.panelSize.toString();

		for (const item of responseData.documents) {
			if (item.type == 2) {
				let responseUrl = null;
				let downloadUrl = null;
				try {
					yield call(handleGetDmParameters);
					const culture = MLHelper.currentLanguage.culture;
					const path = item?.viewOptions?.existingDocumentPath;
					const requestUrl =
						yield ServiceList.dm.DocumentManagement.Explorer.GetDMObjectsFromPath.call({
							path,
							culture
						});
					const requestItem = requestUrl.items[0];

					const requestParameters = {
						addRecent: false,
						secretKey: requestItem?.secretKey,
						versionSecretKey: null
					};
					responseUrl =
						yield ServiceList.dm.DocumentManagement.Objects.GetDownloadUrl.callPromise(
							requestParameters,
							true
						);
					downloadUrl =
						(window as any).serviceConfig.services.dm.baseURL + '/' + responseUrl;
				} catch (error) {
					MessageBox.error({ error: error.exception.data });
				}

				Mobile.MobileView.setDocumentStructure('GetDownloadUrl', downloadUrl);
				Mobile.MobileView.setDocumentStructure('SendFormMessage', sendIFrameJson);
			}
		}
	}

	const panelSize = parseInt(menuPanelSize || documentPanelSize || 2);

	const startProps: IFlowViewerProps = {
		...parameters,
		flowStartParameters: responseData,
		activeDocumentName: defDocumentName,
		projectName: parameters?.projectName || '',
		fromMobile: forMobile,
		mobileFormView
	};

	const maxButtonVisible: string = parameters?.['maximizable'] || 'true';
	if (isNullOrUndefined(parameters?.openOnType) || parameters?.openOnType == 'panel') {
		return yield call(
			openNewPanelInsteadOfTheOtherOne,
			activePanelId,
			{
				title: null, // Bu değer form.caption.text propertysi ile yüklenecektir.
				paneltype: panelType.flowViewer,
				parent: parent,
				role: actionRole.flowForm,
				initialSize: panelSize,
				size: panelSize,
				extraProps: startProps,
				canHandleCloseEvent: handleCloseEvent,
				forMobile: forMobile,
				MaxButtonHide: !(maxButtonVisible == 'true'),
				isCloseButtonHide: parameters?.isCloseButtonHide
			},
			false,
			closeUnpinnedPanels
		);
	}

	if (activePanelId) {
		yield put(closeFlexPanelByIdTransactionAction(activePanelId));
	}

	const guid = createGuid();
	yield call(openPanelComponent, {
		id: guid,
		title: '',
		panelType: panelType.flowViewer,
		parentPanel: parent,
		type: parameters?.openOnType,
		props: startProps,
		closePanelId: activePanelId,
		width: MainUtils.panelSizeToWidth(panelSize),
		addNewToStore: {
			enable: true,
			panelData: FlowViewerPanelContentFactoryFromJS({
				openedOn: parameters?.openOnType
			}),
			setPanelDataPanelId: true
		},
		maskClosable: false
	});
	return guid;
}

export function getFlowDocumentName(args: { documentName: string; viewName: string }) {
	return `${args.documentName}_${args.viewName}`;
}

export function getFlowDocumentNameFromDocument(document: IFlowDocument) {
	let suffix = document.viewOptions.viewName;
	if (document.type == FlowDocumentType.AddExisting) {
		suffix = document.viewOptions.existingDocumentPath.split('/').pop();
	}
	return `${document.name}_${suffix}`;
}

export function* setLeftMenuPanelContent(panelContent: LeftMenuState) {
	yield put(
		setPanelContentAction({
			panelType: panelType.LeftMenu,
			data: panelContent
		})
	);
}

export function* waitAgentReady() {
	if (!ProjectHelper.isAgentsReady) {
		yield take((action: IBaseAction<any>) => action.type == DEPLOY_AGENT_READY);
	}
}

export function* openFlowViewerFromQueryModel(queryModel: any, fromMobile = false) {
	try {
		const state: WebInterfaceBaseState = yield select();
		const parameters: FlowViewerParameters = {
			...queryModel,
			projectVersion: queryModel.packageVersion,
			clientUrl: queryModel.url,
			flowName: queryModel.flowName,
			processId: queryModel.processId,
			requestId: queryModel.requestId || queryModel.processRequestId,
			events: queryModel.events,
			isCloseButtonHide: queryModel.isCloseButtonHide
		};

		const childGuid = yield call(
			triggerStartAProcess,
			parameters,
			'',
			fromMobile,
			false,
			parameters.mobileFormView
		);

		let leftMenuPanelContent = state.layouts.leftMenu;
		leftMenuPanelContent = leftMenuPanelContent
			.set('activePanelId', childGuid)
			.set('activePanelType', panelType.flowViewer);
		yield call(setLeftMenuPanelContent, leftMenuPanelContent);

		return childGuid;
	} catch (error) {
		console.log('openFlowViewerFromQueryModel error', error);
	}
}

function* handleRedirectForMobile(payload: WebInterfaceAction) {
	const responseItem = payload.data;

	if (responseItem?.language) {
		localStorage.setItem('locale', responseItem.language);
		findMessage.updateCulture(responseItem.language);
	}

	const isOutlook = responseItem?.menuItem?.isOutlook?.length;
	yield put(changeForMobileStateAction({ data: !isOutlook }));
	if (isOutlook) {
		yield fork(handleGetDmParameters);
	}

	if (responseItem?.menuItem) {
		const selectedItem: IMenuItem = responseItem.menuItem;
		const childGuid: string = yield call(handleOpenPanel, selectedItem, parent, true);
		if (!childGuid) {
			yield cancel();
		}
		const state: WebInterfaceBaseState = yield select();
		const panelContent: LeftMenuState = LeftMenuStateFactoryFromJS({
			activePanelId: childGuid,
			activePanelType: getPanelTypeFromNodeActionType(selectedItem.nodeActionType),
			items: state.layouts.leftMenu.items.toJS(),
			activeNodeKey: selectedItem.id,
			menuDesigner: state.layouts.leftMenu.menuDesigner.toJS()
		});
		yield call(setLeftMenuPanelContent, panelContent);
	} else if (responseItem?.processRequest) {
		responseItem.processRequest.url = responseItem.processRequest.url + '/api';
		responseItem.processRequest.clientUrl = responseItem.processRequest.url;
		if (responseItem.processRequest.isScopeForm) {
			yield call(openDraftForm, responseItem.processRequest);
		} else {
			yield call(openFlowViewerFromQueryModel, responseItem.processRequest, true);
		}
	} else {
		const state: WebInterfaceBaseState = yield select();
		const activePanelId: string = state.layouts.leftMenu.activePanelId;
		yield put(closeFlexPanelByIdTransactionAction(activePanelId, 'disableStartUp'));
		yield put(closeAllMessageBoxesAction());
	}
}

function* initForMobile(args: IMobileQueryString) {
	yield fork(handleGetDmParameters);
	if (args.menuItem) {
		const selectedItem: IMenuItem = args.menuItem;
		let childGuid: string = null;
		if (selectedItem.nodeActionType == nodeActionType.Startup) {
			childGuid = yield call(
				openNewPanelInsteadOfTheOtherOne,
				'',
				{
					title: findMessage.get('100765'),
					paneltype: panelType.startupLayout,
					parent: parent,
					initialSize: 3,
					size: 3,
					MaxButtonHide: true,
					canHandleCloseEvent: false,
					forMobile: true,
					disableResize: true,
					transparentBackground: true,
					headerHide: true
				},
				false,
				null
			);
		} else {
			childGuid = yield call(handleOpenPanel, selectedItem, parent, true);
		}
		if (!childGuid) {
			yield cancel();
		}
		const state: WebInterfaceBaseState = yield select();
		const panelContent: LeftMenuState = LeftMenuStateFactoryFromJS({
			activePanelId: childGuid,
			activePanelType: getPanelTypeFromNodeActionType(selectedItem.nodeActionType),
			items: state.layouts.leftMenu.items.toJS(),
			activeNodeKey: selectedItem.id,
			menuDesigner: state.layouts.leftMenu.menuDesigner.toJS()
		});
		yield call(setLeftMenuPanelContent, panelContent);
	}
}

export function getStartupNodeId(items: Array<IMenuItem>): string {
	return items.find(q => q.nodeActionType === nodeActionType.Startup)?.id || '';
}

export function* getMenuStructure() {
	try {
		const response: IMenu = yield ServiceList.workflow.MenuManager.GetUserMenuStructure.call();
		if (response?.nodes?.length) {
			let items: Array<IMenuItem> = filterDesignerItems(response.nodes);
			items = sortItemChildren(items, false);
			yield put(leftMenuSaveItems({ items }));
			yield put(seteBA6Enabled(response.eBA6Enabled));
			yield put(leftMenuSetActiveNodeKey({ data: getStartupNodeId(items) }));
			return items;
		}
	} catch (e) {
		BCNotification.error({ message: findMessage.get('100704') });
	}
}

function* changeLoadingStatus(status: boolean) {
	yield put(
		panelOnChangeLoadingStatusTransaction({
			panelId: 'LEFTMENU',
			panelType: panelType.LeftMenu,
			data: status
		})
	);
}

function* openDraftForm(parameters: IRedirectProcessRequestModel) {
	try {
		const response = yield call(ProjectHelper.RunGeneratorFormService, {
			projectName: parameters.projectName,
			formName: 'project/forms',
			serviceName: 'GetFormInfoById',
			requestParameters: { id: parameters.documentId }
		});

		if (response?.data) {
			const { data } = response;
			const deploymentUrl = ProjectHelper.getDeploymentUrl(data.project, null, null);

			const childFormData = {
				deploymentUrl,
				projectName: data.project,
				formName: data.form,
				childFormDataLoaded: true,
				documentId: parameters.documentId,
				loading: false,
				secretKey: data.secretKey
			};

			const panelConfig = {
				title: data.caption,
				paneltype: panelType.eBAApplicationForm,
				parent: parent,
				initialSize: 2,
				size: 2,
				canHandleCloseEvent: false,
				extraProps: { childFormData },
				addNewToStore: true
			};

			return yield call(openNewPanelInsteadOfTheOtherOne, '', panelConfig);
		} else {
			return null;
		}
	} catch (error) {
		console.log('[OpenDraftItem][Error]: ', error);
		BCNotification.error({ message: findMessage.get('102681') });
		return null;
	}
}
